import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { JsonLd } from "@/components/site/JsonLd";
import { buildPageStructuredData } from "@/data/schema";
import { useLang } from "@/i18n/LangContext";
import { readPageMeta } from "@/lib/pageMetaStore";

/**
 * Route-aware JSON-LD. Must render AFTER <Routes> so PageMeta has published
 * title/description into pageMetaStore during the same render pass.
 */
export const SiteSchema = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();
  const { title, description } = readPageMeta();

  const data = useMemo(
    () => buildPageStructuredData({ pathname, lang, title, description }),
    [pathname, lang, title, description],
  );

  return <JsonLd data={data} />;
};
